import { render, staticRenderFns } from "./FilterStarsBlock.vue?vue&type=template&id=defeb6e6&"
import script from "./FilterStarsBlock.vue?vue&type=script&lang=js&"
export * from "./FilterStarsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports